import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: `app.containers.WorkflowEditor.components.Rules.Condition.components.PartnerTitleInput.title`,
    defaultMessage: 'Title',
  },
});
